import { render, staticRenderFns } from "./POStatusPopup.vue?vue&type=template&id=1354ab06"
import script from "./POStatusPopup.vue?vue&type=script&lang=js"
export * from "./POStatusPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports